import { translate } from "@locales";

export function BlogsHeader(){
  return (
    <section id="EducationalTop" className="flex justify-center">
      <div className="max-sm:w-[336px] flex sm:mt-11 md:justify-center sm:mb-6 mb-8 mt-16">
        <div className="text-center font-chivo-regular">
          <h1 className="font-bold text-3xl md:text-4xl mb-4  md:mb-5">
            {translate("educational.markers")}
          </h1>
          <p className="text-sm md:text-lg text-dark-gray">
            {translate("educational.filter")}
          </p>
        </div>
      </div>
    </section>
  );
}
